export default {
    name: "promo-item",
    props: {
        list: {
            type: Array,
            default: () => [],
        },
    },
    components: {},
    methods: {
        generateProp() {
            let schema = {
                "@context": "https://schema.org/",
                "@type": "BreadcrumbList",
                itemListElement: [],
            };
            let homeUrl = this.$router.resolve(this.$linkwrap({ name: "home" }));
            schema.itemListElement.push({
                "@type": "ListItem",
                position: 1,
                name: this.$t("mainPage"),
                item: window.location.origin + homeUrl.route.path,
            });
            let breadCrumbsList = this.list.filter(item => item.slug.length);
            breadCrumbsList.map((item, index) => {
                schema.itemListElement.push({
                    "@type": "ListItem",
                    position: index + 2,
                    name: item.title,
                    item:
                        window.location.origin +
                        this.$router.resolve(this.$linkwrap({ name: item.name, params: { categorySlug: item.slug } }))
                            .route.path,
                });
            });
            return schema;
        },
    },
};
